import { createSlice } from "@reduxjs/toolkit";
import {
  acceptResult,
  deleteResult,
  getAllResultCategory,
  getResult,
  rejectResult,
  undoDeleteResult,
} from "./Result.api";

const resultCategorySlice = createSlice({
  name: "result",
  initialState: {
    result: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getResult.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getResult.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getResult.rejected, (state, action) => {
      state.loading = false;
    });

    // Accept Result
    builder.addCase(acceptResult.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(acceptResult.fulfilled, (state, action) => {
      state.loading = false;
      const { _id } = action.payload.data;
      if (state.result.data) {
        const index = state.result.data.findIndex((item) => item._id === _id);
        if (index !== -1) {
          state.result.data[index].status = "Accepted";
        }
      }
    });
    builder.addCase(acceptResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Reject Result
    builder.addCase(rejectResult.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(rejectResult.fulfilled, (state, action) => {
      state.loading = false;
      const { _id } = action.payload.data;
      if (state.result.data) {
        const index = state.result.data.findIndex((item) => item._id === _id);
        if (index !== -1) {
          state.result.data[index].status = "Decline";
        }
      }
    });
    builder.addCase(rejectResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getAllResultCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllResultCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.resultAllCategory = action.payload;
    });
    builder.addCase(getAllResultCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteResult.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteResult.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.result.data) {
        state.result.data = state.result.data.filter((result) => {
          return result._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error("state.result.data is not an array:", state.result.data);
      }
      state.loading = false;
    });
    builder.addCase(deleteResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteResult.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteResult.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.result.data) {
        state.result.data = state.result.data.filter((result) => {
          return result._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error("state.result.data is not an array:", state.result.data);
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteResult.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = resultCategorySlice.actions;
export default resultCategorySlice.reducer;
